<template>
  <b-card
    id="shipment-statuses"
    no-body
    class="p-1"
  >
    <app-collapse>
      <app-collapse-item
        title="Shipment Statuses"
        header-style="h4-style"
        :is-visible="isShipmentCollapseOpen"
        @visible="loadShipmentData"
      >
        <b-table
          class="mt-2"
          :fields="shipmentsStatisticsFields"
          :items="shipmentStatistics"
          :busy="!isDataLoaded"
          show-empty
        >
          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle mr-1" />
              <strong>Loading...</strong>
            </div>
          </template>

          <template #cell(name)="data">
            <router-link :to="data.item.link">
              <strong :class="data.item.class">{{ data.item.name }}</strong>
            </router-link>
          </template>

          <template #cell(available)="data">
            <router-link :to="data.item.link">
              <strong
                v-b-tooltip.hover.top="'Available'"
                class="text-primary"
                :class="data.item.class"
              >
                {{ data.item.available }}
              </strong>
            </router-link>
          </template>

          <template #cell(done)="data">
            <router-link :to="data.item.link">
              <strong
                v-b-tooltip.hover.top="'Done'"
                class="text-success"
                :class="data.item.class"
              >
                {{ data.item.done }}
              </strong>
            </router-link>
          </template>

        </b-table>
      </app-collapse-item>
    </app-collapse>
  </b-card>
</template>

<script>
import {
  BCard,
  VBTooltip,
  BTable, BSpinner,
} from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import { EventBus } from '@core/utils/utils'

export default {
  components: {
    BSpinner,
    AppCollapseItem,
    AppCollapse,
    BCard,
    BTable,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: ['shipmentsStatisticsFields', 'shipmentStatistics', 'shipmentId', 'isDataLoaded', 'showStatuses'],
  data() {
    return {
      isOpen: false,
      isShipmentCollapseOpen: false,
    }
  },
  created() {
    if (this.showStatuses) {
      this.isShipmentCollapseOpen = true
      this.loadShipmentData()
    }
  },
  methods: {
    loadShipmentData() {
      if (!this.isDataLoaded) {
        EventBus.$emit('load-shipment-statistics')
        this.isOpen = true
      }
    },
  },
}
</script>
